import { NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  NgZone,
} from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';

@Component({
  selector: '[app-update-toast]',
  standalone: true,
  imports: [NgIf],
  template: `
    <button
      *ngIf="options.closeButton"
      type="button"
      class="toast-close-button"
      aria-label="Dismiss update notification"
      (click)="dismiss($event)"
    >
      <span aria-hidden="true">&times;</span>
    </button>
    <div class="update-notification" role="status" aria-live="polite">
      <div class="update-notification__title">
        A new version of MANGO is available.
      </div>
      <button
        type="button"
        class="update-notification__action"
        (click)="updateNow($event)"
      >
        Update now
      </button>
    </div>
  `,
  styles: [
    `
      :host {
        width: min(390px, calc(100vw - 24px));
        padding: 16px 18px;
        background-color: #263238;
        background-image: none;
        border-left: 4px solid #42a5f5;
        border-radius: 4px;
        box-shadow: 0 4px 14px rgba(0, 0, 0, 0.24);
        color: #fff;
      }

      .update-notification {
        padding-right: 18px;
      }

      .update-notification__title {
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 600;
        line-height: 1.4;
      }

      .update-notification__action {
        padding: 0;
        border: 0;
        background: transparent;
        color: #90caf9;
        cursor: pointer;
        font: inherit;
        font-weight: 600;
      }

      .update-notification__action:hover,
      .update-notification__action:focus-visible {
        color: #fff;
        text-decoration: underline;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppUpdateToastComponent extends Toast {
  constructor(
    toastrService: ToastrService,
    toastPackage: ToastPackage,
    ngZone: NgZone,
  ) {
    super(toastrService, toastPackage, ngZone);
  }

  updateNow(event: Event): void {
    event.stopPropagation();
    this.toastPackage.triggerAction();
  }

  dismiss(event: Event): void {
    event.stopPropagation();
    this.remove();
  }
}
